import React from "react";
import Play from '../images/play.svg';

const VideoPlayButton = () => {
  return (
    <div className="video-play-button">
      <img className="video-icon" src={Play} alt="Play icon" />
    </div>
  )
}

export default VideoPlayButton;
